import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="bg-[#0A1224] text-white min-h-[70vh] flex items-center">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-24 text-center">
        <div className="text-xs font-black uppercase tracking-[0.2em] text-slate-400 mb-6">Error 404</div>
        <h1 className="text-6xl md:text-8xl font-black tracking-tighter mb-6">
          That page <span className="text-[#FF8A00]">isn't on the map.</span>
        </h1>
        <p className="text-slate-300 text-lg mb-10 max-w-xl mx-auto">
          The page you're looking for either moved or hasn't shipped yet. Continuum is in
          build — we'll only link to pages that exist.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="bg-[#FF8A00] text-[#050A15] font-bold px-6 py-3.5 hover:bg-[#FFA833] inline-flex items-center gap-2"
        >
          <Home size={18} /> Back to home
        </Link>
      </div>
    </section>
  );
}
